import { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { Row, Col, Collapse } from "antd";
import { useHandleForm } from "../../../hooks/useHandleForm";
import { FormBlock, FormField, IButton, Spinner } from "../../../ui-kit";
import rolesStore from "../../../store/roles";
import { useStatusMessage } from "../../../hooks/useStatusMessage";

import styles from "../Roles.module.scss";

const { Panel } = Collapse;

const RoleForm: FC = observer((values) => {
  const {
    deleteRole,
    saveRole,
    cloneRole,
    roleStateStatus,
    permissionsData,
    getRolePermissions,
    permissionsIsLoading,
  } = rolesStore;

  const initialValues = {
    id: values?.record?.id,
    name: values?.record?.name,
    title: values?.record?.title,
    description: values?.record?.description,
    sessionLifetime: values?.record?.sessionLifetime,
    sessionCount: values?.record?.sessionCount,
  };

  useEffect(
    () => values?.record?.id && getRolePermissions(values?.record?.id),
    [],
  );

  const { register, handleSubmit, watchAllField, reset } = useHandleForm(
    null,
    initialValues,
    {},
  );

  const onSubmit = (values) => {
    saveRole(values);
  };

  const onDeleteRole = () => {
    deleteRole(values.record.id);
  };

  const onСloneRole = () => {
    const data = {
      name: watchAllField.name ?? watchAllField.name,
      description: watchAllField.description ?? watchAllField.description,
      groupId: values?.record.id,
    };
    cloneRole(data).then(() => {
      reset(initialValues);
    });
  };

  useStatusMessage(roleStateStatus);
  return (
    <>
      <form
        className={styles.SmsSettingsParamsForm}
        onSubmit={handleSubmit(onSubmit)}
      >
        <FormBlock>
          <Row gutter={[15, 20]}>
            <Col span={8}>
              <FormField
                label="Название"
                name="name"
                register={register}
                type="text"
                currentValue={watchAllField.name}
                isRequired
              />
            </Col>
            <Col span={8} className="form-block__data-header">
              <FormField
                label="Описание"
                name="description"
                register={register}
                type="text"
                currentValue={watchAllField.description}
                isRequired
              />
            </Col>
            <Col className="form-block__data-header">
              <IButton className={styles.RolesButton} type="submit">
                Сохранить
              </IButton>
              <IButton onClick={onDeleteRole} className={styles.RolesButton}>
                Удалить
              </IButton>
            </Col>
          </Row>
          <Row gutter={[15, 20]}>
            <Col span={16}>
              <Collapse className={styles.Permissions}>
                <Panel header="Права" key="1">
                  {permissionsIsLoading.value &&
                  !permissionsData[values?.record?.id] ? (
                    <Spinner className={styles.Spinner} />
                  ) : (
                    <p>
                      {permissionsData[values?.record?.id]
                        ?.map(
                          (permission) =>
                            `${
                              permission.moduleName
                                ? `${permission.moduleName}.`
                                : ""
                            }${
                              permission.entityName
                                ? `${permission.entityName}.`
                                : ""
                            }${
                              permission.permissionActionName ||
                              permission.permissionActionString ||
                              ""
                            }`,
                        )
                        .join(", ")}
                    </p>
                  )}
                </Panel>
              </Collapse>
            </Col>
          </Row>
        </FormBlock>
      </form>
      {values?.record?.id && (
        <IButton onClick={onСloneRole} className={styles.CloneRolesButton}>
          Создать копию
        </IButton>
      )}
    </>
  );
});

export default RoleForm;
